import React from 'react';
import { StyledUnorderedList } from './styles/BulletText.styles';

const BulletTextControl = ({ control }) => (
  <StyledUnorderedList styleProps={control.attributes}>
    {control.items.map((item, index) => <li key={index}>{item}</li>)}
  </StyledUnorderedList>
);

export default BulletTextControl;